export default "__VITE_ASSET__ciRJrGzX__"